const miniHowItWorksData = [
  {
    id: 1,
    title: "FOLLOW GAME-DAY ACTION",
    text: "Earn points every time the action lands in the zone your token represents.",
    icon: "bolt",
  },
  {
    id: 2,
    title: "COLLECT REWARDS",
    text: "Redeem your points for gift cards, exclusive merch, or exclusive experiences of your choosing.",
    icon: "star",
  },
  {
    id: 3,
    title: "UNLOCK UNIQUE EXPERIENCES",
    text: "Sideline access, locker room tours, and meet-and-greets with Falcons stars.",
    icon: "trophy",
  },
  {
    id: 4,
    title: "MAKE A REAL IMPACT",
    text: "Your token purchases fund pediatric care, research, and family support at CHOA.",
    icon: "heart",
  },
];

export default miniHowItWorksData;
